import { z } from "zod";

export const promoteToAdminFormSchema = z
    .object({
        confirmPassword: z.string().min(1, "Please confirm the password"),
        email: z.string().email("Please enter a valid email address"),
        password: z.string().min(6, "Password must be at least 6 characters"),
    })
    .refine((data) => data.password === data.confirmPassword, {
        message: "Passwords do not match",
        path: ["confirmPassword"],
    });

export type PromoteToAdminFormData = z.infer<typeof promoteToAdminFormSchema>;
